import * as Redux from 'redux';
import { IState } from '../interfaces';
import { auth } from './auth';

/** Main reducer object */
export const Main: Redux.Reducer<IState> = Redux.combineReducers({
  auth
});
